<template>
  <div ref="layout" class="page-form">
    <h3 class="title">发货入口</h3>

    <div class="table-container">
      <TableCommon
        title="老要货系统开票产品"
        :custome-config="() => vxeShowCustom('xTable')"
        :pagination="pagination1"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions3.columns"
          :data="gridOptions3.data"
        >
          <template #action="{ row }">
            <el-link type="primary" size="mini" @click="goOldApplyForGoods(row)">要货</el-link>
          </template>
          <template #infType="{ row }">
            <span>{{ filterDictionary(row.infType, 'A0022') }}</span>
          </template>
          <template #zzfld000001="{ row }">
            <span>{{ filterDictionary(row.zzfld000001, 'orgList','SOBID', 'MC_SHORT') }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon
        title="新要货系统已开票产品"
        :custome-config="() => vxeShowCustom('xTable')"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          :row-style="rowStyle"
        >
          <template #action="{ row }">
            <el-link type="primary" size="mini" @click="goApplyForGoodsEdit(row)">要货</el-link>
          </template>
          <template #infType="{ row }">
            <span>{{ filterDictionary(row.infType, 'A0022') }}</span>
          </template>
          <template #acceptUnitType="{ row }">
            <span>{{ filterDictionary(row.acceptUnitType, 'A0009') }}</span>
          </template>
          <template #zzfld000001="{ row }">
            <span>{{
              filterDictionary(row.zzfld000001, 'orgList', 'zzfld00001h', 'mc_short')
            }}</span>
          </template>
          <template #zZFLD00002Q="{ row }">
            <span>{{ filterDictionary(row.zZFLD00002Q, 'A0002') }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
      <TableCommon
        title="以酒促酒产品"
        :custome-config="() => vxeShowCustom('xWineTable')"
        :pagination="pageWine"
        @pagination-change="handleTablePaginationChange"
      >
        <template #button>
            <table-button name="add" tip="要货" @click="goApplyWineGoods" />
          </template>
        <vxe-grid
          ref="xWineTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridWineOptions.columns"
          :data="gridWineOptions.data"
          :row-style="rowStyle"
        >
          <template #infType="{ row }">
            <span>{{ filterDictionary(row.infType, 'A0022') }}</span>
          </template>
          <template #acceptUnitType="{ row }">
            <span>{{ filterDictionary(row.acceptUnitType, 'A0009') }}</span>
          </template>
          <template #zzfld000001="{ row }">
            <span>{{
              filterDictionary(row.zzfld000001, 'orgList', 'zzfld00001h', 'mc_short')
            }}</span>
          </template>
          <template #zZFLD00002Q="{ row }">
            <span>{{ filterDictionary(row.zZFLD00002Q, 'A0002') }}</span>
          </template>
          <template #availableQty="{ row }">
            <span>{{ handleNum(row) }}</span>
          </template>
          
        </vxe-grid>
      </TableCommon>
      <!-- <TableCommon
        title="存新酒产品"
        :custome-config="() => vxeShowCustom('xTable')"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions4.columns"
          :data="gridOptions4.data"
        >
          <template #action="{ row }">
            <el-link type="primary" size="mini" @click="goApplyForGoodsEdit(row)">要货</el-link>
          </template>
          <template #infType="{ row }">
            <span>{{ filterDictionary(row.infType, 'A0022') }}</span>
          </template>
          <template #acceptUnitType="{ row }">
            <span>{{ filterDictionary(row.acceptUnitType, 'A0009') }}</span>
          </template>
          <template #zzfld000001="{ row }">
            <span>{{
              filterDictionary(row.zzfld000001, 'orgList', 'zzfld00001h', 'mc_short')
            }}</span>
          </template>
          <template #zZFLD00002Q="{ row }">
            <span>{{ filterDictionary(row.zZFLD00002Q, 'A0002') }}</span>
          </template>
        </vxe-grid>
      </TableCommon> -->
      <TableCommon
        title="受让货权转移产品"
        :custome-config="() => vxeShowCustom('xTable2')"
        :pagination="pagination2"
        @pagination-change="handleTablePaginationChange"
      >
        <vxe-grid
          ref="xTable2"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions2.columns"
          :data="gridOptions2.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions2.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-link
                v-if="gridOptions2.columnsFieldTypes[item.field] == 'action'"
                type="primary"
                size="mini"
                @click="goApplyForTransfer(row)"
              >要货</el-link>
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
          <template #invTypeTextView="{ row }">
            <span>{{ filterDictionary(row.invTypeTextView, 'A0022') }}</span>
          </template>
          <template #zZFLD00002Q="{ row }">
            <span>{{ filterDictionary(row.zZFLD00002Q, 'A0002') }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog :title="dialogTitle" :visible.sync="showDialog" width="70%" :append-to-body="true">
      <template v-if="showDialog">
        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
    <!-- 二次确认弹框 -->
    <el-dialog title="选择要货方式" :visible.sync="againDialog" width="50%" :append-to-body="true">
      <template v-if="againDialog">
        <div style="margin-bottom: 20px;">
          <p>
            贵公司老要货系统还剩余开票产品未要货，剩余数量（{{oldRow.availableQty}}）件，建议优先使用老要货系统要货。
          </p>
          说明:点击取消则关闭此弹窗，点击确认进入新要货申请，点击老要货则进入老要货申请。
        </div>
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="againDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="confirmHandle"
        >确认</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="goOldApplyForGoods"
        >老要货</el-button>
      </div>
    </el-dialog>
    <!-- 页面通用弹窗情况 -->
    <!-- <el-dialog
      title="编辑"
      :visible.sync="showPageEditDialog"
      fullscreen
      :before-close="beforeClose"
      :append-to-body="true"
    >
      <apply-for-goods-edit
        v-if="showPageEditDialog"
        :mode="mode"
        :row-data="currentData"
        :distribute-cust-list="distributeCustList"
        @close="closePageEditDialog"
      />
    </el-dialog> -->
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { Message } from 'element-ui'
import {
  apiGetUnFinishedInv,
  apiGetTransferGoodsInvInfo,
  apiGetListDistributeCust,
  apiGetYQInvoice,
  getUnFinishedInvByStore,
  getUnFinishedInvByPromote
} from '@/api/applyForGoods/index'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'

// import ApplyForGoodsEdit from '../components/ApplyForGoodsEdit.vue'
import { filterDictionary } from '@/utils/index'
import { mapGetters } from 'vuex'

const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const rules = {
  customerName: [{ required: true, message: '请选择订单客户', trigger: 'blur' }]
}

export default {
  components: {
    ClientSelect
    // ApplyForGoodsEdit
  },
  data() {
    return {
      oldRow: null,
      saveRow: null,
      againDialog: false,
      rules: rules,
      isClient: '0',
      showDialog: false,
      dialogTitle: '客户选择',
      loading: false,
      showPageEditDialog: false,
      mode: 'edit',
      currentData: {},
      id: '',
      conditions: {
        saleCenter: '',
        saleCenterView: '',
        customerCode: '',
        customerName: '',
        department: '',
        createdDate: ''
      },
      customerType: '',
      distributeCustList: {},
      validRules: {},
      selectDataOptions: {
        province: [],
        city: [],
        saleCenter: [],
        orgList: []
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0,
        loadingOptions: [{ target: '.table-block', text: '数据加载中...' }]
      },
      pagination1: {
        page: 1,
        pagesize: 200,
        totalCount: 0,
        loadingOptions: [{ target: '.table-block', text: '数据加载中...' }]
      },
      pagination2: {
        page: 1,
        pagesize: 50,
        totalCount: 0,
        loadingOptions: [{ target: '.table-block', text: '数据加载中...' }]
      },
      pagination4: {
        page: 1,
        pagesize: 50,
        totalCount: 0,
        loadingOptions: [{ target: '.table-block', text: '数据加载中...' }]
      },
      pageWine: {
        page: 1,
        pagesize: 50,
        totalCount: 0,
        loadingOptions: [{ target: '.table-block', text: '数据加载中...' }]
      },
      gridOptions: {
        buttons: [],
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'annual', title: '年度', width: 80 },
          { field: 'custName', title: '开票客户' },
          { field: 'orderCustName', title: '订单客户' },
         // { field: 'acceptUnitType', title: '客户类型' , slots: { default: 'acceptUnitType' }},
          { field: 'infType', title: '制票通知单类型', slots: { default: 'infType' }},
          { field: 'zZFLD00002Q', title: '销售计划类型', slots: { default: 'zZFLD00002Q' }},
          { field: 'zzfld000001TextView', title: '营销中心' },
          { field: 'productDesc', title: '产品名称' },
          {
            field: 'invoiceQty',
            title: '开票总量(件)',
            width: 100
          },
          { field: 'deliveryQty', title: '已发数量' },
          { field: 'availableQty', title: '剩余量' },
          { field: 'ticketDetailId', title: 'ticketDetailId',visible: false },
          { field: 'action', title: '操作', slots: { default: 'action' }}
        ],
        data: [],
        columnsFieldTypes: {
          zZFLD00002Q: 'select',
          action: 'action'
        }
      },
      gridOptions2: {
        buttons: [],
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          // { field: 'invoiceNo', title: '制票单编号', slots: { default: 'invoiceNo' }},
          { field: 'zZFLD00002Q', title: '销售计划', slots: { default: 'zZFLD00002Q' }},
          { field: 'transferClient', title: '来源客户', slots: { default: 'transferClient' }},
          { field: 'customer', title: '开票客户编号' },
          { field: 'custName', title: '开票客户名称' },
          { field: 'receiveClientCode', title: '订单客户编号' },
          { field: 'receiveClient', title: '订单客户名称' },
          { field: 'infTypeTextView', title: '制票通知单类型' },
          { field: 'productCode', title: '产品编码', slots: { default: 'productCode' }},
          { field: 'productDesc', title: '产品名称', slots: { default: 'productDesc' }},
          // { field: 'invoiceQuantity', title: '开票数量', slots: { default: 'invoiceQuantity' }},
          // { field: 'thisTransferQuantity', title: '转移数量', slots: { default: 'thisTransferQuantity' }},
          { field: 'transferQty', title: '接收量', slots: { default: 'transferQty' }},
          // { field: 'deliveryQuantity', title: '已发货量', slots: { default: 'deliveryQuantity' }},
          { field: 'deliveryQuantity', title: '已发货量', slots: { default: 'deliveryQuantity' }},
          { field: 'totalTransfer', title: '已转移量', slots: { default: 'totalTransfer' }},
          { field: 'availableQty', title: '接收剩余量', slots: { default: 'availableQty' }},
          { field: 'action', title: '操作', slots: { default: 'action' }}
        ],
        data: [],
        columnsFieldTypes: {
          action: 'action'
        }
      },

      gridOptions3: {
        buttons: [],
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'annual', title: '年度' },
          { field: 'zzfld000001', title: '营销中心', slots: {default: 'zzfld000001'} },
          { field: 'ZZFLD00002Q', title: '销售计划类型' },
          { field: 'orderCust', title: '订单客户编号' },
          { field: 'orderCustName', title: '订单客户名称' },
          { field: 'infType', title: '制票通知单类型', slots: { default: 'infType' }},
          { field: 'productCode', title: '产品编码' },
          { field: 'productDesc', title: '产品名称' },
          { field: 'invoiceQty', title: '开票数量' },
          { field: 'transferQty', title: '转移数量' },
          { field: 'deliveryQty', title: '已发货量' },
          { field: 'availableQty', title: '剩余量' },
          { field: 'action', title: '操作', slots: { default: 'action' }}
        ],
        data: [],
        columnsFieldTypes: {
          action: 'action'
        }
      },
      gridOptions4: {
        buttons: [],
        columns: [
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'zZFLD00002Q', title: '销售计划类型', slots: { default: 'zZFLD00002Q' }},
          // { field: 'annual', title: '来源客户', width: 80 },
          { field: 'customer', title: '开票客户编号' },
          { field: 'custName', title: '开票客户名称' },
          { field: 'orderCust', title: '订单客户编号' },
          { field: 'orderCustName', title: '订单客户名称' },
          { field: 'infType', title: '制票通知单类型', slots: { default: 'infType' }},
          { field: 'productCode', title: '产品编码' },
          { field: 'productDesc', title: '产品名称' },
          { field: 'invoiceQty', title: '开票数量' },
          { field: 'deliveryQty', title: '已发数量' },
          // { field: 'availableQty', title: '储存截止日期' },
          { field: 'availableQty', title: '剩余量' },
          { field: 'action', title: '操作', slots: { default: 'action' }}
        ],
        data: [],
        columnsFieldTypes: {
          action: 'action'
        }
      },
      gridWineOptions: {
        buttons: [],
        columns: [
          // { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { type: 'checkbox', title: '', field: 'checkbox', width: 40 },
          { field: 'annual', title: '年度', width: 80 },
          { field: 'custName', title: '开票客户' },
          { field: 'orderCustName', title: '订单客户' },
         // { field: 'acceptUnitType', title: '客户类型' , slots: { default: 'acceptUnitType' }},
          { field: 'infType', title: '制票通知单类型', slots: { default: 'infType' }},
          { field: 'zZFLD00002Q', title: '销售计划类型', slots: { default: 'zZFLD00002Q' }},
          { field: 'invoId', title: '发票号' },
          { field: 'zzfld000001TextView', title: '营销中心' },
          { field: 'productDesc', title: '产品名称' },
          {
            field: 'invoiceQty',
            title: '开票总量(件)',
          },
          {
            field: 'useBot',
            title: '开票总量(瓶)',
          },
          { field: 'deliveryQty', title: '已发数量(件)' },
          { field: 'availableQty', title: '剩余量(件)' },
          { field: 'availableBot', title: '剩余量(瓶)' },
          { field: 'ticketDetailId', title: 'ticketDetailId',visible: false },
        ],
        data: [],
        columnsFieldTypes: {
          zZFLD00002Q: 'select',
          action: 'action'
        }
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    sum() {
      const sum = this.gridOptions.data.reduce((p, c) => {
        return +c.freezeQuantity + p
      }, 0)
      return sum
    },
    isEdit() {
      return this.conditions.status === 1
    }
  },
  created() {
    this.initDetail()
    this.$nextTick(() => {
      this.getListDistributeCust()
    })
    apiGetOrgOrBase('', 1).then(res => {
      this.selectDataOptions['orgList'] = res.DATA
    })
    if (this.$route.query.id) {
      this.id = this.$route.query.id
    } else {
      this.conditions.createdDate = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
      this.conditions.department = this.userInfo.deptName
    }
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0022')
    this.getSelectDictDataOrigin('A0011')
    this.getSelectDictDataOrigin('A0002')

  },
  methods: {
    // 以酒促酒要货
    goApplyWineGoods(){
      const data = this.$refs.xWineTable.getCheckboxRecords()
      if(data.some(item => item.zzfld000001 !== data[0].zzfld000001)){
        return Message.warning('请选择相同营销单元的产品！')
      }
      if(data.some(item => item.invoId !== data[0].invoId)){
        return Message.warning('请选择相同发票号的产品！')
      }
      if(data.every(item => item.productCode === data[0].productCode)){
        let qtyNum = 0
        let botNum = 0
        data.forEach((ele,index) => {
          qtyNum += ele.availableQty - 0
          botNum += ele.availableBot - 0
        });
        qtyNum = qtyNum + parseInt(botNum/Number(data[0].xzhs))
        botNum = botNum%Number(data[0].xzhs)
        const row = {
          ...data[0],
          availableQty: qtyNum,
          availableBot: botNum
        }
        console.log(`output->row`,row)
        if(row.availableQty - 0 === 0){
          return Message.warning('选择的酒不够一件')
        }
        this.$emit('changeActive', 'toGoods', row)
      }else{
        return Message.warning('请选择相同的酒！')
      }
    },
    rowStyle({ row, rowIndex }) {
      if (row.isold - 0 === 1) {
        return {
          backgroundColor: 'rgb(229, 228, 226)',
        }
      }
    },
    confirmHandle(){
      this.saveRow && this.$emit('changeActive', 'toGoods', this.saveRow)
      this.againDialog = false
    },
    filterDictionary,
    async initDetail() {
      this.loading = true
      const { page, pagesize } = this.pagination
      const { customerCode, customerName } = this.conditions
      const params = {
        customerCode,
        customerName,
        page,
        pagesize,
        valid: true,
        demandType: 1
      }
      try {
        const res = await apiGetUnFinishedInv(params)
        this.loading = false
        if (res?.status === 1) {
          const { Rows, Total, page } = res.data
          this.gridOptions.data = Rows
          this.pagination.totalCount = Total
          this.pagination.page = page
        }
        const res2 = await apiGetTransferGoodsInvInfo(params)
        this.loading = false
        const { Rows, Total, page } = res2.data
        this.gridOptions2.data = Rows
        this.pagination2.totalCount = Total
        this.pagination2.page = page

        const res5 = await getUnFinishedInvByPromote(params)
        this.loading = false
        if (res5?.status === 1) {
          const { Rows, Total, page } = res5.data
          this.gridWineOptions.data = Rows
          this.pageWine.totalCount = Total
          this.pageWine.page = page
        }
        const res3 = await apiGetYQInvoice(params)
        this.loading = false
        if (res3?.status === 1) {
          this.gridOptions3.data = res3.data
          this.pagination1.totalCount = res3.data.length
        }
      //   const res4 = await getUnFinishedInvByStore(params)
      //  this.loading = false
      //   if (res4?.status === 1) {
      //     const { Rows, Total, page } = res4.data
      //     this.gridOptions4.data = Rows
      //     this.gridOptions4.totalCount = Total
      //     this.pagination4.page = page
      //   }
        
      } catch (error) {
        //
      }
      this.loading = false
    },
    async getListDistributeCust() {
      const { customerCode } = this.conditions
      const params = {
        customerCode
      }
      try {
        const res = await apiGetListDistributeCust(params)
        if (res?.status === 1) {
          this.distributeCustList = {}
        }
      } catch (error) {
        //
      }
    },
    // 选择营销单元
    saleCenterChange(e) {
      const checkedData = this.selectDataOptions.orgList.find(v => v.zzfld00001h === e)
      this.conditions.ZZFLD000001Name = checkedData.mc_short
      this.conditions.ZZFLD00003E = checkedData.zzfld00003e
      this.conditions.ZZFLD00003EName = checkedData.mc_short_jd
    },
    // 处理分页事件table
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.initDetail()
    },
    goApplyForGoodsEdit(row) {
      this.saveRow = null
      this.oldRow = null
      const havePd = this.gridOptions3.data.find(v => row.productCode === v.productCode)
      if (havePd) {
        this.againDialog = true
        this.oldRow = havePd
        this.saveRow = row
      }else{
        this.$emit('changeActive', 'toGoods', row)
      }
      // const havePd = this.gridOptions3.data.find(v => row.productCode === v.productCode)
      // if (havePd) {
      //   this.$confirm('该产品在老要货系统还有剩余量，请先前往老要货系统', '提示', {
      //     confirmButtonText: '立即前往',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     const url = 'http://yh.wuliangye.com.cn:82'
      //     window.open(url)
      //   })
      //   return
      // }
      // this.$emit('changeActive', 'toGoods', row)
      //   this.currentData = row
      //   this.showPageEditDialog = true
    },
    goOldApplyForGoods() { // 跳转老要货系统
      // const url = 'http://10.0.133.131:82'
      // http://10.0.137.69:8081/enduser/go_6d4877aeb68bfb4e85008e6c37656bfbwNkU8xNgIzg
      this.againDialog = false
      const url = 'http://yh.wuliangye.com.cn:82'
      window.open(url)
    },
    goApplyForTransfer(row) {
      this.$emit('changeActive', 'toGoods', row)
    },
    // 弹窗关闭前操作
    beforeClose(done) {
      done()
    },
    // 关闭编辑页面
    closePageEditDialog() {
      this.showPageEditDialog = false
    },

    openDialog(e, title) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return

      if (this.dialogTitle === '客户选择') {
        this.conditions.customerCode = data.customerCode
        this.conditions.customerName = data.customerName
      }
      this.showDialog = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/components/DeliverApply.vue